// src/components/admin/InitializeRoomsButton.jsx
// Temporary component to initialize room data in Firestore

import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { dataService } from '../../services/dataService';

const sampleRooms = [
  {
    id: 'room-001',
    name: 'Treatment Room 1',
    capacity: 2,
    status: 'available',
    type: 'treatment',
    equipment: ['Treatment Table', 'Chair', 'Storage Cabinet'],
    description: 'Main treatment room for physiotherapy sessions',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'room-002',
    name: 'Treatment Room 2',
    capacity: 2,
    status: 'available',
    type: 'treatment',
    equipment: ['Treatment Table', 'Exercise Equipment', 'Mirror'],
    description: 'Secondary treatment room with exercise equipment',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'room-003',
    name: 'Consultation Room',
    capacity: 3,
    status: 'available',
    type: 'consultation',
    equipment: ['Desk', 'Chairs', 'Computer'],
    description: 'Private consultation room for client meetings',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'room-004',
    name: 'Group Exercise Room',
    capacity: 8,
    status: 'available',
    type: 'group',
    equipment: ['Yoga Mats', 'Exercise Balls', 'Resistance Bands', 'Sound System'],
    description: 'Large room for group exercise sessions and classes',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'room-005',
    name: 'Massage Room',
    capacity: 1,
    status: 'available',
    type: 'massage',
    equipment: ['Massage Table', 'Towel Warmer', 'Essential Oils Storage'],
    description: 'Dedicated massage therapy room',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
];

const InitializeRoomsButton = () => {
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const handleInitialize = async () => {
    if (initialized) {
      toast.error('Rooms have already been initialized');
      return;
    }

    setLoading(true);
    try {
      console.log('🏥 Initializing room data in Firestore...');

      for (const room of sampleRooms) {
        await dataService.create('rooms', room);
        console.log(`✅ Added room: ${room.name}`);
      }

      console.log('🎉 Successfully initialized all rooms!');
      toast.success(`Successfully added ${sampleRooms.length} rooms to Firestore!`);
      setInitialized(true);

    } catch (error) {
      console.error('❌ Error initializing rooms:', error);
      toast.error('Failed to initialize rooms: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border border-orange-200 bg-orange-50 rounded-lg">
      <h3 className="text-lg font-semibold text-orange-800 mb-2">
        Initialize Room Data
      </h3>
      <p className="text-sm text-orange-700 mb-4">
        Click the button below to add sample room data to your Firestore database.
        This will create a "rooms" collection with 5 sample rooms.
      </p>
      <button
        onClick={handleInitialize}
        disabled={loading || initialized}
        className={`px-4 py-2 rounded-lg font-medium ${initialized
            ? 'bg-green-100 text-green-800 cursor-not-allowed'
            : loading
              ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
              : 'bg-orange-600 text-white hover:bg-orange-700'
          }`}
      >
        {loading ? 'Initializing...' : initialized ? '✅ Rooms Initialized' : '🏥 Initialize Rooms'}
      </button>
      {initialized && (
        <p className="text-sm text-green-600 mt-2">
          ✅ Room data has been successfully added to Firestore!
        </p>
      )}
    </div>
  );
};

export default InitializeRoomsButton;
